import React from "react";
// import { useSelector } from "react-redux";
import RouteCondition from "@/helper/PoRouteCondition";
import { pages } from "@/routes/pageImports";

// Utility function to create routes with 'auth' type RouteCondition
const createAuthRoute = (path, Component) => ({
  path,
  element: <RouteCondition type="auth" userRole={"PLACEMENT_OFFICER"} Component={Component} />,
});

const onboardingRoutes = (path, Component) => ({
  path,
  element: <RouteCondition type="onboarding" Component={Component} userRole="PLACEMENT_OFFICER" />,
});

// Utility function to create routes with 'private' type RouteCondition for Placement Officer
const createPrivateRoute = (path, Component) => ({
  path,
  element: (
    <RouteCondition
      type="private"
      userRole="PLACEMENT_OFFICER"
      Component={Component}
    />
  ),
});



// Main function to dynamically generate routes based on mode
const PoRoutes = () => {
  // const { mode } = useSelector((state) => state.auth); // Fetch the mode from Redux state

  // Define auth routes for Placement Officer
  const poAuthRoutes = [
    createAuthRoute("/po/register", pages.LetsBeginPage),
    createAuthRoute("/po/login", pages.NewLoginPage),
    createAuthRoute("/:userType/create-password", pages.CreatePassPage),
    createAuthRoute("/po/otp", pages.CommonOtpPage),
    createAuthRoute("/po/payment", pages.PayemntPage),
    // createAuthRoute("/po/plan-price", pages.PlanPricingIndex),

  ];

  const poOnboardingRoutes = [
    // onboardingRoutes("/po/pricing", pages.Pricing),
    onboardingRoutes("/po/pricing", pages.PlanPricingIndex),
    onboardingRoutes("/po/billing", pages.BillingPage),
    onboardingRoutes("/po/contact-info", pages.ContactInfoPage),
    onboardingRoutes("/po/college-address", pages.CollegeAddressPage),
    onboardingRoutes("/po/edit/college-address", pages.CollegeAddressPage),
    onboardingRoutes("/po/college-info", pages.CollegeInfoPage),
    onboardingRoutes("/po/college-academic", pages.CollegeAcademicInfoPage),
    onboardingRoutes("/po/pricing", pages.PlanPricingIndex),

  ]

  // Define private routes for Placement Officer
  const poPrivateRoutes = [

    createPrivateRoute("/po/*", pages.PoDashboardIndex),
    createPrivateRoute("/po/settings/*", pages.SettingIndex),
    createPrivateRoute("/po/plan-price", pages.PlanPricingIndex),
  ];

  return { poAuthRoutes, poOnboardingRoutes, poPrivateRoutes };
};

export default PoRoutes;
